import styled from 'styled-components';
import _map from 'lodash/map';
import media from 'styles/media';

const MODIFIER = {
  flexFill: media.IE11 || media.IE10 ? 'flex: 1 1 100%' : 'flex: 1 1 auto;',
  fillHeight: 'height: 100%;',
};

const applyModifier = modifiers => {
  if (!modifiers) {
    return '';
  }
  return _map(modifiers, modifier => MODIFIER[modifier]);
};

export const Div = styled.div`
  display: flex;
  ${props => (props.ie9Height && media.IE9 ? `
    height: ${props.ie9Height}px;
  ` : '')};
  ${props => applyModifier(props.modifier)};
`;

export const ColumnDiv = styled(Div)`
  flex-direction: column;
`;
